import { Component, OnDestroy, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { SecurityProfileEnum } from 'src/app/enums/securityProfile.enum';
import { AuthService } from 'src/app/services';
import { AiAnalystScopeService } from 'src/app/services/ai-analyst-scope.service';
import { PermissionService } from 'src/app/services/permission.service';
import { findFirstReadableAiAnalystAdminTab, getAiAnalystAdminRouteConfig } from 'src/app/shared/constants/aiAnalystAdminRouteConfig.constants';
import { RoutePaths } from 'src/app/shared/constants/routePaths.constants';

@Component({
  standalone: false,
  selector: 'app-ai-analyst-admin',
  templateUrl: './ai-analyst-admin.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrls: ['./ai-analyst-admin.component.scss']
})
export class AiAnalystAdminComponent implements OnInit, OnDestroy {
  section = '';
  tabs: { routerLink: string; title: string; objectId?: string }[] = [];

  private readonly destroy$ = new Subject<void>();

  constructor(
    private readonly authService: AuthService,
    private readonly route: ActivatedRoute,
    private readonly router: Router,
    private readonly permissionService: PermissionService,
    private readonly aiAnalystScopeService: AiAnalystScopeService
  ) { }

  ngOnInit(): void {
    const isSuperAdmin = this.authService.getCurrentUser().userType === SecurityProfileEnum.SuperAdmin;
    this.aiAnalystScopeService.canAccessAiAnalyst$.pipe(takeUntil(this.destroy$)).subscribe({
      next: (canAccessAiAnalyst) => (this.tabs = getAiAnalystAdminRouteConfig(isSuperAdmin, canAccessAiAnalyst)),
    });
    this.section = this.route.snapshot.data['section'] ?? '';

    if (!this.tabs.length) {
      this.router.navigate([this.authService.getLandingPageUrl()]);
      return;
    }

    if (!this.isSectionVisible()) {
      this.router.navigateByUrl(
        findFirstReadableAiAnalystAdminTab(this.tabs, (objectId) => this.permissionService.hasReadPermission(objectId))?.routerLink ?? RoutePaths.unauthorized
      );
    }
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }

  private isSectionVisible(): boolean {
    return this.tabs.some((tab) => tab.routerLink.endsWith(`/${this.section}`));
  }
}
